import {FACTIONS} from "../../../constants/factions";
import {isUnitFaction} from "../isUnitFaction";
import {getHexDistance} from "../../coords/getHexDistance";
import {DEMONS_ABILITY_RANGE} from "../../../configs/factions/demons";

export const calculateEnemyDemonsInRange = (ownerId, hexKey, units, enemyId, range = DEMONS_ABILITY_RANGE) => {
  let demonsAmount = 0;

  for (const unit of units) {
    if (unit.ownerId === ownerId) {
      continue;
    }

    // Учитываем демонов только того оппонента, против которого ведется бой
    if (isUnitFaction(unit, FACTIONS.DEMONS) && unit.ownerId === enemyId) {
      const demonHexKey = unit.hexKey;
      const isInRange = getHexDistance(hexKey, demonHexKey) <= range;

      if (isInRange) {
        demonsAmount += unit.size;
      }
    }

  }

  return demonsAmount;
}